import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import StarRatings from "react-star-ratings";
import { Link } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

import {
  CarouselProvider,
  DotGroup,
  ImageWithZoom,
  Slide,
  Slider,
} from "pure-react-carousel";
import { cartAdd } from "../../actions/cart";
import { retreiveByQuickViewId } from "../../actions/products";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ToastContainer, toast } from "react-toastify";

const ProductModal = (props) => {
  //   console.log(props.show);

  const [show, setShow] = useState(props.show);
  const [loading, setLoading] = useState(true);

  const [ApiData, setApiData] = useState({});
  const [product, setProduct] = useState({});

  useEffect(() => {
    let ignore = false;

    setShow(props.show);
    async function fetchData() {
      const res = await props.retreiveByQuickViewId(props.id);
      setApiData(res[0]);

      setProduct(res[0].products[0]);
      setLoading(false);
    }
    fetchData();

    return () => {
      ignore = true;
    };
  }, [props.show]);
  console.log(loading);
  const [quantity, setQuantity] = useState(1);

  const _addToWishlist = async (item) => {
    const wishlistData = localStorage.getItem("wishlist");
    if (wishlistData && wishlistData.length > 0) {
      const arr = JSON.parse(wishlistData);
      var a = true;
      arr.forEach((e, index) => {
        if (e._id === item._id) {
          a = false;
          arr.splice(index, 1);
          toast(`Product removed from wishlist`, { containerId: "B" });
        }
      });
      if (a === true) {
        arr.push(item);
      }
      localStorage.setItem("wishlist", JSON.stringify(arr));
    } else {
      localStorage.setItem("wishlist", JSON.stringify([item]));
    }
    if (a !== false) {
      // setShow(false);
      toast(`Product added to wishlist`, { containerId: "B" });
    }
  };

  const handleClose = () => {
    setShow(false);
  };
  const _addToCart = async (item) => {
    console.log(item);

    const data = {
      item: item,
      quantity,
    };
    const cartAdd = await props.cartAdd(data);
    if (cartAdd) {
      setShow(false);
      setQuantity(1);

      toast(`Product added in cart`, { containerId: "B" });
    }
  };
  console.log(ApiData);

  return (
    <React.Fragment>
      <ToastContainer
        enableMultiContainer
        containerId={"B"}
        position={toast.POSITION.TOP_RIGHT}
      />
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        style={{ marginTop: "2%", boxShadow: "none" }}
      >
        {!loading ? (
          <Modal.Body>
            {show && show === true && product ? (
              <div className="container-fluid">
                <div className="row">
                  <div
                    className="modal-close"
                    onClick={handleClose}
                    data-dismiss="modal"
                  >
                    <span closeButton>×</span>
                  </div>
                  <div className="col-md-6">
                    <div className="modal-left-side">
                      <div className="moda-left-heading">
                        <h2>{product && product.title}</h2>
                      </div>
                      <div className="modal-seemore">
                        See More from{" "}
                        <Link to={`/brand/${ApiData.brands[0].slug}`}>
                          {ApiData.brands[0].slug}
                        </Link>
                      </div>
                      <div className="modal-reviews">
                        <ul id="modal-stars">
                          <StarRatings
                            rating={
                              ApiData && ApiData.reviews
                                ? ApiData.reviews.length
                                : 0
                            }
                            starDimension="20px"
                            starSpacing="2px"
                            starRatedColor="gold"
                          />
                          <span>{ApiData && ApiData.reviews.length}</span>
                        </ul>
                      </div>
                      <div className="modal-slider">
                        <CarouselProvider
                          visibleSlides={1}
                          totalSlides={product && product.images.length}
                          step={1}
                          naturalSlideWidth={400}
                          naturalSlideHeight={400}
                          hasMasterSpinner
                        >
                          <Slider>
                            {product &&
                              product.images &&
                              product.images.map((item, index) => (
                                <Slide index={index}>
                                  <ImageWithZoom src={item.ftpUrl} />
                                </Slide>
                              ))}
                          </Slider>

                          <DotGroup />
                        </CarouselProvider>
                      </div>
                    </div>{" "}
                    {/*END MODAL LEFT SIDE*/}
                  </div>
                  <div
                    className="col-md-6"
                    style={{ backgroundColor: "hsla(240,5%,96%,.85)" }}
                  >
                    <div className="moda-right-side">
                      <div className="modal-right-price">
                        <span className="m-price">
                          $
                          {product.enableSale === true
                            ? Number(
                                product.price -
                                  (product.price * product.saleDiscount) / 100
                              ).toFixed(2) * quantity
                            : Number(product.price).toFixed(2) * quantity}
                        </span>
                        <span>
                          {product.enableSale === true ? (
                            <del className="moda-right-price-off">
                              ${Number(product.price).toFixed(2)}
                            </del>
                          ) : null}
                        </span>
                      </div>
                      <div className="modal-shiping-dete">
                        <span>FREE Shipping</span>
                        <span>Get it Now</span>
                      </div>

                      <div className="modal-right-collapse">
                        <div className="accordion" id="accordion">
                          <div className="card mt-3">
                            <div className="checkout-inps">
                              <span className="selectcountry-hint">
                                Select Quantity
                              </span>
                              <select
                                className="countrySelect"
                                onChange={(e) => {
                                  setQuantity(e.target.value);
                                }}
                              >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                              </select>
                            </div>
                          </div>
                          <div className="card mt-3">
                            <div
                              id="product-description"
                              className="collapse-heading"
                            >
                              <button
                                className="btn btn-link collapsed py-md-3"
                                type="button"
                                data-toggle="collapse"
                                data-target="#description-collapse"
                                aria-expanded="false"
                                aria-controls="description-collapse"
                              >
                                Description
                                <span>
                                  <i className="fa fa-angle-down" />
                                </span>
                              </button>
                            </div>
                            <div
                              id="description-collapse"
                              className="collapse"
                              aria-labelledby="product1description"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <div className="discription-body">
                                  <div className="description-content">
                                    <p>{product && product.description}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* <div className="card mt-3">
                          <div
                            id="product-spesification"
                            className="collapse-heading"
                          >
                            <button
                              className="btn btn-link collapsed py-md-3"
                              type="button"
                              data-toggle="collapse"
                              data-target="#spesification-collapse"
                              aria-expanded="false"
                              aria-controls="spesification-collapse"
                            >
                              Specifications
                              <span>
                                <i className="fa fa-angle-down" />
                              </span>
                            </button>
                          </div>
                          <div
                            id="spesification-collapse"
                            className="collapse"
                            aria-labelledby="product1spesification"
                            data-parent="#accordion"
                          >
                            <div className="card-body">
                              <div className="spesification-content">
                                {quickView &&
                                  quickView.specification &&
                                  quickView.specification.specification.map(
                                    (e, index) => (
                                      <div
                                        key={index}
                                        className="product-weight"
                                      >
                                        {" "}
                                        {JSON.parse(e).value &&
                                        JSON.parse(e).value !== "" ? (
                                          <React.Fragment>
                                            <div className="overall-weight">
                                              <p className="m-0 py-2">
                                                {JSON.parse(e).name}
                                              </p>
                                            </div>
                                            <p className="m-0 py-2">
                                              {JSON.parse(e).value}
                                            </p>
                                          </React.Fragment>
                                        ) : null}
                                      </div>
                                    )
                                  )}
                              </div>
                            </div>
                          </div>
                        </div> */}

                          <div className="modal-end-btns">
                            <button
                              type="button"
                              className="modal-add-cart"
                              onClick={(e) => {
                                e.preventDefault();
                                _addToCart(product && product);
                              }}
                            >
                              <span>Add To Cart</span>
                            </button>
                            <button
                              type="button"
                              className="modal-save-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                _addToWishlist(product && product);
                              }}
                            >
                              <span>
                                <i className="far fa-heart" /> Save
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              "<div></div>"
            )}
          </Modal.Body>
        ) : (
          <div className="text-center mt-5 mb-5">
            <CircularProgress />
          </div>
        )}

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
cartAdd.propTypes = {
  cartAdd: PropTypes.func.isRequired,
};

retreiveByQuickViewId.propTypes = {
  retreiveByQuickViewId: PropTypes.func.isRequired,
};

export default connect(null, { cartAdd, retreiveByQuickViewId })(ProductModal);
